import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { ClassRoom } from '../classroom.js';
import { normalizeJoinCode } from '../utils/join-code.js';

/**
 * Open lookup by join code, intentionally unauthenticated — this is the student's
 * pre-confirmation screen (and the `/join?code=` deep link) before they necessarily have an
 * account. Returns `[]` rather than throwing when the code doesn't resolve.
 */
export const getClassRoomByCodeQuery = registerQuery({
  operationName: 'getClassRoomByCodeQuery',
  type: () => [ClassRoom],
  params: [{ name: 'code', type: () => String }],

  resolve: (code: string) => async (_gqlFields: BaseQLSelectionSet<ClassRoom>): Promise<ClassRoom[]> => {
    const normalizedCode = normalizeJoinCode(code);
    if (!normalizedCode) return [];

    const classroomCollection = await getCollection(ClassRoom);
    const classroom = await classroomCollection.findOne({ code: normalizedCode });

    return classroom ? [classroom as ClassRoom] : [];
  },
});
